export default {
    namespaced: true,
    pbx_master_account: {
      title: "Conta Master | Contas Master",
      name: "nome",
      domain: "dominio",
      sip_port: "Porta SIP",
      tls_sip_port: "Porta SIP TLS",
      ws_url: "WS URL",
      ws_binding_port: "Porta WS",
      wss_binding_port: "Porta WSS",
      external_sip_ip: "IP SIP externo",
      external_rtp_ip: "IP RTP externno",
      call_recording: "Gravação de chamadas habilitada",
      queue_timeout: "Tempo limite da fila",
      seconds: "segundos",
      api_url: "API URL",
    },
  };
